import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router';

import { url } from 'helpers';
import { useAuth } from 'hooks';
import { ProfileIncompletePage } from 'pages';
import { ProfileStatus } from 'types/models';
import { RouteProps } from 'types/routes';

const authorizedStatuses: ProfileStatus[] = [
  ProfileStatus.APPROVED,
  ProfileStatus.SUSPENDED,
];

const PrivateRoute: FC<RouteProps> = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.authenticated) {
    const returnUrl = location.pathname + location.search;

    return <Navigate to={url.toLogin()} state={{ returnUrl }} />;
  }

  if (auth.status && !authorizedStatuses.includes(auth.status)) {
    return <ProfileIncompletePage />;
  }

  return children;
};

export default PrivateRoute;
